import * as apiService from "../api.service";
import { SachbezugDivision } from "@models/SachbezugDivision";
import { UpsertSachbezugDivisionError } from "./errors";
import { isAxiosError } from "axios";

export async function upsertSachbezugDivision(
	sachbezugDivision: SachbezugDivision
) {
	try {
		await apiService.PUT(
			`sachbezug/division/${sachbezugDivision.divisionId}`,
			sachbezugDivision.toUpdatePayload()
		);
	} catch (error) {
		if (isAxiosError(error) && error.response?.data.message) {
			throw new UpsertSachbezugDivisionError(error.response.data.message);
		}
		throw new UpsertSachbezugDivisionError();
	}
}
